var FileUploadQueueService = (function () {
    function FileUploadQueueService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    FileUploadQueueService.prototype.getAll = function (CompanyID) {
        return this.$http.post(this.WsUrl + "/GetAllFileUploadQueue", {
            CompanyID: CompanyID
        });
    };
    FileUploadQueueService.$inject = ["$http"];
    return FileUploadQueueService;
}());
angular
    .module("London.Services")
    .service("FileUploadQueueService", FileUploadQueueService);
